import { useEffect } from "react";

const DEFAULT_TITLE = "Soho Goa | Best Bollywood Nightclub in Baga & Calangute – Night Club in Goa";
const DEFAULT_DESC = "Soho Goa — the best Bollywood nightclub in Baga, North Goa, minutes from Tito's Lane on Calangute–Baga Road. Bollywood & commercial DJ nights, WhatsApp table booking, online cover passes. Open 9 PM till late.";

export const useMeta = (title, description, path) => {
  useEffect(() => {
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    const previous = meta?.getAttribute("content") || DEFAULT_DESC;
    if (meta) meta.setAttribute("content", description);
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://sohogoa.com${path}`;
    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.setAttribute("content", previous);
      canonical.href = "https://sohogoa.com/";
    };
  }, [title, description, path]);
};
